<style lang="less">
    @import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="img-title">
            <img src="@/assets/tip.png"/>
            <span>由版权家为你自行上传的作品进行具有法律效力的版权存证，版权家不对您上传内容的真实性作验证。</span>
        </div>
        <div style="min-height: 670px;height: auto;" class="table-list">
            <div class="table-list-title">
                <span style="margin-left:25px">我的监测</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker v-model="dateValue"
                                 format="yyyy-MM-dd"
                                 type="daterange"
                                 placement="bottom-end"
                                 placeholder="选择日期"
                                 @on-change="timeChange"
                                 style="width: 200px">
                    </Date-picker>
                    <div class="father-box-input">
                        <input
                                v-model="searchValue"
                                @keyup.enter="searchReset"
                                placeholder="请输入监测名称"
                                class="select-input-self">
                        </input>
                        <img @click="searchReset" src="@/assets/search.png" class="search-icon"/>
                    </div>
                    <button @click="searchReset" class="btn-84">查询</button>
                    <router-link class="btn-84" style="margin:0 30px 0 20px;display: inline-block;text-align: center"
                                 to="/monitor">新增监测
                    </router-link>
                </div>
            </div>
            <Tabs @on-click="tabClick" :value="tabType">
                <Tab-pane label="图片" name="image">
                    <monitorComponents v-show="tabType == 'image'"
                                       @fatherReceivePage="receiveChildrenPage"
                                       :data="imageData"
                                       :total="imageTotal"
                                       :pageSize="pageSize"
                                       :pages="imageAllPages"></monitorComponents>
                </Tab-pane>
                <Tab-pane label="音乐" name="music">
                    <monitorComponents v-show="tabType == 'music' "
                                       @fatherReceivePage="receiveChildrenPage"
                                       :data="musicData"
                                       :total="musicTotal"
                                       :pageSize="pageSize"
                                       :pages="musicAllPages"></monitorComponents>
                </Tab-pane>
                <Tab-pane label="文字" name="word">
                    <monitorComponents v-show="tabType == 'word'"
                                       @fatherReceivePage="receiveChildrenPage"
                                       :data="wordData"
                                       :total="wordTotal"
                                       :pageSize="pageSize"
                                       :pages="wordAllPages"></monitorComponents>
                </Tab-pane>
            </Tabs>
        </div>
    </div>

</template>

<script>
    import Cookies from "js-cookie";
    import {_contentGetValidByPage} from '@/api/monitor.js';
    import monitorComponents from './myMonitor-components';
    import errorTips from '@/views/main-components/error-tips';


    export default {
        metaInfo: {
            title: '我的监测|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        name: 'myMonitor',
        data() {
            return {
                userInfo: '', //用户信息
                tabType: 'image', //当前选中类型
                imageData: {}, //图片数据
                musicData: {}, //音乐数据
                wordData: {}, //文字数据
                dateValue: [], //日期数组
                searchValue: '', //搜索值
                pageNumber: 1, //当前页码
                pageSize: 5, //当前页码尺寸
                imageTotal: 0,
                imageAllPages: 0,
                musicTotal: 0,
                musicAllPages: 0,
                wordTotal: 0,
                wordAllPages: 0,
            }
        },
        components: {
            monitorComponents,
            errorTips
        },
        created() {
            if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                this.userInfo = JSON.parse(Cookies.get("userInfo"));
                this.contentGetValidByPage();
            } else {
                this.$router.push("/login");
            }

        },
        methods: {
            /***************分类切换**************/
            tabClick(value) {
                let oldType = this.tabType;
                if (oldType != value) {
                    this.tabType = value;

                    if (this.searchValue != '' || this.dateValue.length != 0) {
                        this.searchValue = '';
                        this.dateValue = [];
                        switch (oldType) {
                            case 'image' :
                                this.imageData = {};
                                this.pageNumber = 1;
                                break;

                            case 'music':
                                this.musicData = {};
                                this.pageNumber = 1;
                                break;

                            default :
                                this.wordData = {};
                                this.pageNumber = 1;
                                break;

                        }


                    }

                    /************重置请求*********/
                    switch (this.tabType) {
                        case 'image' :
                            if (JSON.stringify(this.imageData) == "{}") {
                                this.pageNumber = 1;
                                this.contentGetValidByPage();
                                break;
                            }
                            break;

                        case 'music':
                            if (JSON.stringify(this.musicData) == "{}") {
                                this.pageNumber = 1;
                                this.contentGetValidByPage();
                                break;
                            }
                            break;

                        default :
                            if (JSON.stringify(this.wordData) == "{}") {
                                this.pageNumber = 1;
                                this.contentGetValidByPage();
                                break;
                            }
                            break;
                    }
                }
            },

            /***************获取详情**************/
            contentGetValidByPage() {
                let data = {
                    type: this.tabType,
                    startTime: (this.dateValue[0] ? this.dateValue[0] : ''),
                    endTime: (this.dateValue[1] ? this.dateValue[1] : ''),
                    monitorName: this.searchValue,
                    registerId: this.userInfo.id,
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    sort: 'create_date',
                    order: 'desc'
                };
                _contentGetValidByPage(data).then(res => {
                    if (res.code == 200) {
                        let result = res.result;

                        if (result.records) {
                            let records = result.records;

                            switch (this.tabType) {
                                case "image":
                                    this.imageData = result;
                                    this.imageTotal = result.total - 0;
                                    this.imageAllPages = result.pages - 0;
                                    break;

                                case "music":
                                    this.musicData = result;
                                    this.musicTotal = result.total - 0;
                                    this.musicAllPages = result.pages - 0;
                                    break;

                                default:
                                    this.wordData = result;
                                    this.wordTotal = result.total - 0;
                                    this.wordAllPages = result.pages - 0;
                                    break;
                            }


                        }


                    }
                })
            },

            /***************搜索重置**************/
            searchReset() {
                this.pageNumber = 1;
                this.contentGetValidByPage();
            },

            /***************日期事件**************/
            timeChange(value) {
                this.dateValue = value;
                this.searchReset();
            },

            /***************接收子组件翻页方法**************/
            receiveChildrenPage(value) {
                console.log(value);
                this.pageNumber = value;
                this.contentGetValidByPage();
            }


        }
    }
</script>
<style scoped lang="less">

    .center-table-list {
        /deep/ .ivu-tabs-bar {
            margin-bottom: 0;
            border-bottom: 0;
        }


        /deep/ .ivu-tabs-nav-container {
            height: 56px;
            line-height: 56px;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            padding-left: 20px;
        }

        /deep/ .ivu-tabs-nav .ivu-tabs-tab {
            width: 62px;
            text-align: left;
            padding: 0px;
            /*margin:0px 22px 0px 28px;*/
            color: rgba(51, 51, 51, 1);
        }

        /deep/ .ivu-tabs-ink-bar {
            background: transparent;
            width: 28px !important;
            height: 1px;
            background: rgba(51, 51, 51, 1);
            bottom: 15px;
        }
    }


</style>